import { get,put } from "../common/remote/base_api";

export const GetDetailscaller = (id) => {
  return get(`admin/get-caller-details/`,{caller_id:id});

};
export const Callerupdatebyid = (id, data) => {
    return put(`/admin/update-caller-details/?caller_id=${id}/`, data);
  };